import { createClient } from "@/config/apollo/apolloClient.config";
import { useAuthenticationState } from "@/hooks/useAuthenticationState/useAuthenticationState";
import { ApolloProvider } from "@apollo/client";
import { useMemo } from "react";
import { ApolloClientProviderProps } from "./ApolloClientProvider.decl";

export function ApolloClientProvider({ children }: ApolloClientProviderProps) {
  const {
    actions: { onSessionExpired, refreshToken },
  } = useAuthenticationState();

  const client = useMemo(
    () => createClient(onSessionExpired, refreshToken),
    [refreshToken, onSessionExpired]
  );

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
